function toggleMenuDesktop() {
  const bg = document.getElementById('menuDesktop');
  const btnShowNavDesk = document.getElementById('btnShowNavDesk');
  if (bg.style.display === 'block') {
    bg.style.display = 'none';
    btnShowNavDesk.style.opacity = '1';
    bg.setAttribute('aria-hidden', true);
    document.body.classList.remove('overflow-y-hidden');
  } else {
    bg.style.display = 'block';
    btnShowNavDesk.style.opacity = '0';
    bg.setAttribute('aria-hidden', false);
    document.body.classList.add('overflow-y-hidden');
  }
}

function showMenuMobile() {
  document.getElementById('menuMobile').style.transform = 'translateX(0)';
  document.getElementById('menuMobile').style.display = 'block';
  document.getElementById('menuMobile').setAttribute('aria-hidden', false);
}

function closeMenuMobile() {
  document.getElementById('menuMobile').style.transform = 'translateX(-100%)';
  document.getElementById('menuMobile').setAttribute('aria-hidden', true);
}

export function initMenu() {
  const btnShowNavDesk = document.getElementById('btnShowNavDesk');
  const btnHideNavDesk = document.getElementById('btnHideNavDesk');
  const btnShowNavMobile = document.getElementById('btnShowNavMobile');
  const btnHideNavMobile = document.getElementById('btnHideNavMobile');

  btnShowNavDesk?.addEventListener('click', toggleMenuDesktop);
  btnHideNavDesk?.addEventListener('click', toggleMenuDesktop);
  btnShowNavMobile?.addEventListener('click', showMenuMobile);
  btnHideNavMobile?.addEventListener('click', closeMenuMobile);
}
